<section class="imgPlaceholder">
  <img class="IXBanner" [src]="image" alt="logo" [ngStyle]="additionalStyles" />
  <div class="imageBanner">
    <div class="mid-layout banner" [ngStyle]="bannerTextStyles">
      <div class="row">
        <div class="col-md-12 p-l">
          <div class="banner-title">{{bannerTitle}}</div>
          <div class="banner-details" *ngIf="bannerSubHeading||bannerDescription">
            <div class="banner-subHeading" *ngIf="bannerSubHeading">{{bannerSubHeading}}</div>
            <div class="banner-subHeading-text" *ngIf="bannerDescription">{{bannerDescription}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
</section>